<template>
	<div class="arp-bpm d-flex flex-row justify-end">
		<az-bpm-action
			:before-action="beforeAction"
			:after-action="afterAction"
			:business-key="chaveDeNegocio"
			:button-attrs="{
				claim: {
					class: getClassButton('claim', `text-none order-0 text-uppercase ${botaoClasse}`),
					outlined: true,
				},
				unclaim: {
					class: getClassButton(
						'unclaim',
						`text-none order-1 ms-3 text-uppercase v-btn--width-auto ${botaoClasse}`,
					),
					text: true,
				},
				complete: {
					class: getClassButton('complete', `text-none order-0 text-uppercase ${botaoClasse}`),
					outlined: true,
				},
				uncomplete: {
					class: getClassButton('uncomplete', `text-none order-1 ms-3 text-uppercase ${botaoClasse}`),
					text: true,
				},
			}"
			:process-key="process_key"
			class="bpm-action-pedido"
		>
			<template #claim="{ button }">
				<span v-if="false">{{ button.label }}</span>
			</template>
			<template #unclaim="{ button }">
				<icone-tooltip
					tamanho="auto"
					icone="mdi-undo-variant"
					:texto="button.label"
					cor="white"
				></icone-tooltip>
			</template>
			<template #uncomplete="{ button }">
				<icone-tooltip
					tamanho="auto"
					icone="mdi-undo-variant"
					:texto="button.label"
					cor="white"
				></icone-tooltip>
			</template>
		</az-bpm-action>
	</div>
</template>
<script>
import arpBpmMixin from '@/views/mixins/bpm/arp-bpm-mixin'

export default {
	mixins: [arpBpmMixin],
	props: {
		chaveDeNegocio: {
			type: String,
			required: true,
		},
		botaoClasse: {
			type: String,
			default: '',
		},
	},
	computed: {
		getBotaoVisivel() {
			if (!this.hasAuthority) return ' d-none'
			return ''
		},
	},
	async created() {
		await this.carregarInstancia(this.chaveDeNegocio)
	},
	methods: {
		buscarBotao(tipo) {
			if (this.componentes) {
				const { button } = this.componentes
				return button[tipo]
			}
			return null
		},
		getClassButton(tipo, classePadrao) {
			let btnClaim = this.buscarBotao(tipo)
			if (btnClaim && !btnClaim.disabled) return classePadrao
			return 'd-none'
		},
		beforeAction() {
			this.ativarCarregamentoManual()
			return true
		},
		async afterAction(task) {
			await this.atualizaInstanciaDoProcesso(task)
			this.desativarCarregamentoManual()
			await this.exibirNotificacoes(task)
			this.$emit('apos-acao-fluxo')
		},
	},
}
</script>
<style lang="stylus" scoped>
.v-divider--vertical
	min-height 50%
	max-height 50%
	align-self center

::v-deep .theme--light.v-btn.v-btn--disabled
	color #c2c2c2 !important

::v-deep .border-white
	border-color white

	&:disabled
		color #c2c2c2 !important
		opacity 1 !important
		border-color #c2c2c2

::v-deep .v-btn--plain .v-btn__content
	opacity 1 !important

	&:hover
		opacity 0.5 !important

::v-deep .bpm-action-pedido *
	color white !important
</style>
